import React, { useEffect, useState } from 'react';
import { rgba, darken } from 'polished';
import { useStoreActions } from 'easy-peasy';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import Fade from 'react-reveal/Fade';
// import { Parallax, Background } from 'react-parallax';
import PageTransition from 'gatsby-v2-plugin-page-transitions';
import BackgroundImage from 'gatsby-background-image';
import getVideoId from 'get-video-id';
import ModalVideo from 'react-modal-video';
import facepaint from 'facepaint';

import SEO from '../components/SEO';
import Container from '../components/Container';
import Footer from '../components/Footer';

import { colors } from '../../tailwind';

// import Blob from '../images/svgs/blob.svg';
import Blob2 from '../images/svgs/blob2.svg';
// import Blob3 from '../images/svgs/blob3.svg';
import Blob4 from '../images/svgs/blob4.svg';
// import AboutDoodles from '../images/svgs/about-bg.svg';
// import Divider from '../images/svgs/divider2.svg';
import Sig from '../images/svgs/signature.svg';

import {
  Hero,
  CTA,
  CTAA,
  About,
  TitleSans,
  Album,
  BlurBg,
  TitleSerif,
  Section,
  Tv,
  Ending,
  Video,
  StreamLinks,
  Book,
  MM,
} from './_index.styles';

const mq = facepaint([
  '@media(min-width: 420px)',
  '@media(min-width: 920px)',
  '@media(min-width: 1120px)',
]);

const IndexPage = ({ data }) => {
  const [videoId, setVideoId] = useState(null);
  const [videoOpen, setVideoOpen] = useState(false);

  const setLightHeader = useStoreActions((state) => state.ui.setLightHeader);
  useEffect(() => {
    setLightHeader(true);
  }, []);

  function openVideo(link) {
    const { id } = getVideoId(link);
    setVideoId(id);
    setVideoOpen(true);
  }

  return (
    <PageTransition>
      <SEO title="Home" />

      <Hero
        css={mq({
          paddingBottom: [0, 140],
        })}
      >
        {/* <BackgroundImage
          fluid={data.hero.childImageSharp.fluid}
          css={[tw`pin`, { position: 'absolute !important', zIndex: -2 }]}
        /> */}

        <Container css={tw`py-16 flex flex-col`}>
          {/* <Logo css={{ width: 300 }} /> */}

          <Fade ssrReveal>
            <h2
              css={[
                tw`mt-10 mb-6 font-thin italic text-5xl md:text-6xl text-left font-serif`,
                { lineHeight: 0.8 },
              ]}
            >
              <span
                css={[
                  tw`text-3xl md:text-5xl relative block`,
                  mq({ left: [0, 12] }),
                ]}
              >
                My name is
              </span>
              <b css={tw`font-black`}>Erwan Muhibbain.</b>
            </h2>
          </Fade>

          <Fade ssrReveal delay={300}>
            <h3
              css={[
                tw`font-normal leading-none mb-12`,
                mq({ fontSize: ['1.75rem', '2rem'] }),
              ]}
            >
              I am a singer-songwriter from Malaysia.
            </h3>
          </Fade>

          <Fade ssrReveal delay={600}>
            <CTA
              to="#video"
              onClick={(e) => {
                e.preventDefault();
                openVideo('https://www.youtube.com/watch?v=zbPkLk8PidI');
              }}
            >
              <span>Watch the video</span>
            </CTA>
          </Fade>
        </Container>

        {/* <Divider css={[tw`absolute pin-b`, { transform: 'scaleX(-1)', zIndex: -2 }]} /> */}
      </Hero>

      <About css={mq({ padding: ['3rem 0', '8rem 0'] })}>
        <Img
          fluid={data.erwan.childImageSharp.fluid}
          alt="Erwan Muhibbain"
          css={mq({
            position: ['absolute !important'],
            width: ['50%', '50vw'],
            zIndex: -2,
            right: ['-1rem', '-1rem'],
            top: ['-2rem', 'calc(50% - 25vw)'],
            margin: '1rem auto',
          })}
        />
        {/* <Blob
          css={{
            fill: colors.primary,
            position: 'absolute',
            width: '80vw',
            zIndex: -2,
            right: -200,
            bottom: -200,
            opacity: 0.1
          }}
        /> */}
        {/* <AboutDoodles
          css={{
            fill: colors.primary,
            position: 'absolute',
            width: '50vw',
            zIndex: -1,
            right: '-5vw',
            bottom: 50,
            opacity: 0.1
          }}
        /> */}

        <Container>
          <div
            css={[tw`max-w-md`, { textShadow: '0 0 15px #fff, 0 0 2px #fff' }]}
          >
            <TitleSans css={[tw`mb-12 text-primary-dark`]}>
              <span>A little bit about</span>
              Me.
            </TitleSans>

            <p>
              I was born on the 19th of July 1976. Since I was small, I had an
              inclination towards the arts, especially music. Early in my
              childhood, my parents sent me to piano lessons and I guess that’s
              where I got the singing and song-writing seed firmly planted in my
              heart.
            </p>
            <p>
              Fast forward to the early part of the 2000s, I committed myself to
              the path of the seeker; seeking higher meaning (InsyaAllah
              إن&nbsp;شاء&nbsp;الله) in this life and in the process, I would
              express those meanings in my songs.
            </p>
            <blockquote css={tw`text-primary-dark`}>
              A song is only alive to me… when I find it’s <b>heart.</b>
            </blockquote>
          </div>
        </Container>
      </About>

      {/* <LogoBig>
        <img src={require('../images/logo.png')} alt="Erwan Muhibbain" />
      </LogoBig> */}

      <Album css={tw`text-white`}>
        <BlurBg color={darken(0.3, '#2043A1')} opacity={0.7}>
          <BackgroundImage fluid={data.mengenalcinta.childImageSharp.fluid} />
        </BlurBg>

        <Container css={tw`flex flex-wrap`}>
          <div css={tw`w-full md:w-1/3 px-4`}>
            <Img
              fluid={data.mengenalcinta.childImageSharp.fluid}
              alt="Mengenal Cinta"
              css={[
                tw`block`,
                { boxShadow: `0 0 40px 0 ${rgba(colors.black, 0.25)}` },
              ]}
            />
          </div>

          <div
            css={tw`w-full md:w-2/3 px-4 flex flex-col justify-end items-start`}
          >
            <TitleSerif css={tw`mt-6 mb-4`}>
              <span>My first album</span>
              Mengenal Cinta
              <StreamLinks css={tw`ml-2`}>
                <a href="https://itunes.apple.com/us/album/mengenal-cinta-ep/id1133759448">
                  <i className="fab fa-apple" />
                </a>
                <a href="https://open.spotify.com/album/2JBSONtSWmsqKDh31PTdR8">
                  <i className="fab fa-spotify" />
                </a>
              </StreamLinks>
            </TitleSerif>
            <h4 css={tw`font-medium opacity-50 text-xl md:text-2xl`}>
              English: Knowing Love
            </h4>

            <div css={tw`flex mt-6`}>
              <Video
                onClick={() =>
                  openVideo('https://www.youtube.com/watch?v=kDHQSVyVpjI')
                }
              >
                <i className="far fa-play-circle" />
                <h5>Talk</h5>
              </Video>
              <Video onClick={() => openVideo('https://youtu.be/i43GrC4pXjk')}>
                <i className="far fa-play-circle" />
                <h5>MTV</h5>
              </Video>
            </div>
          </div>
        </Container>
      </Album>

      <Album css={tw`text-white`}>
        <BlurBg color={darken(0.8, '#B1C371')} opacity={0.7}>
          <BackgroundImage fluid={data.floh.childImageSharp.fluid} />
        </BlurBg>

        <Container css={tw`flex flex-wrap`}>
          <div css={tw`w-full md:w-1/3 px-4`}>
            <Img
              fluid={data.floh.childImageSharp.fluid}
              alt="Fear.Love.Hope"
              css={[
                tw`block`,
                { boxShadow: `0 0 40px 0 ${rgba(colors.black, 0.25)}` },
              ]}
            />
          </div>

          <div
            css={tw`w-full md:w-2/3 px-4 flex flex-col justify-end items-start`}
          >
            <TitleSerif css={tw`mt-6`}>
              <span>The second album</span>
              Fear&middot;Love&middot;Hope
              <StreamLinks css={tw`ml-2`}>
                <a href="https://itunes.apple.com/my/album/fear-love-hope/id1134834547">
                  <i className="fab fa-apple" />
                </a>
                <a href="https://open.spotify.com/album/2rLsrKlj9CXsDgFK6YQ455">
                  <i className="fab fa-spotify" />
                </a>
              </StreamLinks>
            </TitleSerif>

            <div css={tw`flex mt-6`}>
              <Video
                onClick={() =>
                  openVideo('https://www.youtube.com/watch?v=ZcqNPPeCKWQ')
                }
              >
                <i className="far fa-play-circle" />
                <h5>Talk</h5>
              </Video>
              <Video
                onClick={() =>
                  openVideo('https://www.youtube.com/watch?v=_plCf30bWms')
                }
              >
                <i className="far fa-play-circle" />
                <h5>MTV</h5>
              </Video>
            </div>
          </div>
        </Container>
      </Album>

      <Album css={tw`text-white`}>
        <BlurBg color={darken(0.8, '#000')} opacity={0.5}>
          <BackgroundImage fluid={data.akuhambamu.childImageSharp.fluid} />
        </BlurBg>

        <Container css={tw`flex flex-wrap`}>
          <div css={tw`w-full md:w-1/3 px-4`}>
            <Img
              fluid={data.akuhambamu.childImageSharp.fluid}
              alt="Aku Hamba Mu"
              css={[
                tw`block`,
                { boxShadow: `0 0 40px 0 ${rgba(colors.black, 0.25)}` },
              ]}
            />
          </div>

          <div
            css={tw`w-full md:w-2/3 px-4 flex flex-col justify-end items-start`}
          >
            <TitleSerif css={tw`mt-6 mb-4`}>
              <span>My third album</span>
              Aku Hamba Mu
              <StreamLinks css={tw`ml-2`}>
                <a href="https://itunes.apple.com/my/album/aku-hamba-mu/id1224057706">
                  <i className="fab fa-apple" />
                </a>
                <a href="https://open.spotify.com/album/0cTFWwnAIhixoGNIqE6gYw">
                  <i className="fab fa-spotify" />
                </a>
              </StreamLinks>
            </TitleSerif>
            <h4 css={tw`font-medium opacity-50 text-xl md:text-2xl`}>
              English: I&rsquo;m Your Servant
            </h4>

            <div css={tw`flex mt-6`}>
              <Video
                onClick={() =>
                  openVideo('https://www.youtube.com/watch?v=qRFyAka4Ay0')
                }
              >
                <i className="far fa-play-circle" />
                <h5>Talk</h5>
              </Video>
              <Video
                onClick={() =>
                  openVideo('https://www.youtube.com/watch?v=-IdVSVZ-w04')
                }
              >
                <i className="far fa-play-circle" />
                <h5>MTV</h5>
              </Video>
            </div>
          </div>
        </Container>
      </Album>

      <Section>
        <Blob4
          css={{
            fill: colors.primary,
            position: 'absolute',
            width: 900,
            zIndex: -2,
            left: -100,
            top: -0,
            opacity: 0.1,
          }}
        />

        <Container>
          <div css={[tw`flex flex-wrap`, { margin: '0 -3rem' }]}>
            <div css={tw`w-full md:w-1/2 px-12`}>
              <TitleSerif css={tw`mb-12 text-grey-darker`}>
                <span>I write &amp; produce</span>
                Songs.
              </TitleSerif>

              <p>
                Alhamdulillah, I am thankful that I also am able to compose,
                write & produce songs for other talents.
              </p>

              <div css={tw`flex mt-6`}>
                <Video
                  onClick={() =>
                    openVideo('https://www.youtube.com/watch?v=Bjb_206yO7U')
                  }
                >
                  <i className="far fa-play-circle" />
                  <h5>Talk</h5>
                </Video>
                <Video
                  onClick={() =>
                    openVideo('https://www.youtube.com/watch?v=QSJ9cAKrJxw')
                  }
                >
                  <i className="far fa-play-circle" />
                  <h5>MTV</h5>
                </Video>
              </div>
            </div>
            <div css={tw`w-full md:w-1/2 px-12 mt-16 md:mt-0`}>
              <TitleSerif css={tw`mb-12 text-grey-darker`}>
                <span>I also compose &amp; write</span>
                Jingles.
              </TitleSerif>

              <p>
                Composing and writing jingles for TV programmes, advertisements
                and such are really fun and exciting for me because they are
                really challenging!
              </p>

              <div css={tw`flex mt-6`}>
                <Video
                  bg={colors.primary}
                  onClick={() =>
                    openVideo('https://www.youtube.com/watch?v=OkOYt_ziD7o')
                  }
                >
                  <i className="far fa-play-circle" />
                  <h5>Talk</h5>
                </Video>
                <Video
                  bg={colors.primary}
                  onClick={() =>
                    openVideo('https://www.youtube.com/watch?v=CuYXVVPvmis')
                  }
                >
                  <i className="far fa-play-circle" />
                  <h5>MTV</h5>
                </Video>
              </div>
            </div>
          </div>
        </Container>
      </Section>

      <Tv>
        <Container>
          <div css={tw`max-w-sm`}>
            <TitleSerif css={[tw`mb-12`]}>
              <span>Sometimes I also do</span>
              Hosting.
            </TitleSerif>

            <p>
              Hosting is also something that I love to do. I’ve hosted some TV
              programmes such as Hadith Open Mic (Behind The Scenes) and Legasi
              Luar Biasa which are both programmes on Astro Oasis.
            </p>
            <p>
              I have also been an emcee for several local and international
              events.
            </p>

            <div css={tw`flex mt-6`}>
              <Video
                bg={colors.primary}
                onClick={() =>
                  openVideo('https://www.youtube.com/watch?v=en7n1CEhD1s')
                }
              >
                <i className="far fa-play-circle" />
                <h5>Watch</h5>
              </Video>
            </div>
          </div>
        </Container>
      </Tv>

      <MM>
        <Container css={tw`flex flex-wrap`}>
          <div
            css={[
              tw`w-full md:w-1/2 flex flex-col justify-center`,
              { padding: '5%', paddingLeft: 0 },
            ]}
          >
            <TitleSerif css={[tw`mb-12`]}>
              <span>My shop</span>
              MahaBBah Mall
            </TitleSerif>

            <p>
              MahaBBah Mall is a vision coming to reality. A vision of a
              collection. A collection of interpretations. Interpretations of
              love. And love — it is endless. Love of meaning embedded in our
              daily lives. Meaning of love expressed in our daily interactions.
              MahaBBah means love. Welcome to MahaBBah Mall.
            </p>
          </div>

          <div
            css={[
              tw`w-full md:w-1/2`,
              {
                background: `url(${require('../images/bgs/mm.jpg')}) no-repeat center/cover`,
              },
            ]}
          >
            <div css={{ paddingTop: '100%' }} />
          </div>
        </Container>
      </MM>

      <Book>
        <Container>
          <div css={tw`max-w-sm`}>
            <TitleSerif css={[tw`mb-12`]}>
              <span>My book</span>
              Mesej • Melodi • Muzik
            </TitleSerif>

            <p>InsyaAllah, coming soon.</p>
          </div>
        </Container>
      </Book>

      <Section>
        <Blob2
          css={{
            fill: '#9A1E1F',
            position: 'absolute',
            width: 900,
            zIndex: -2,
            left: -100,
            bottom: -50,
            opacity: 0.1,
          }}
        />

        <Container>
          <div css={[tw`flex flex-wrap items-center`, { margin: '0 -3rem' }]}>
            <div css={tw`w-full md:w-1/2 px-12`}>
              <TitleSerif css={[tw`mb-12`, { color: '#9A1E1F' }]}>
                <span>If you want to go far… go</span>
                Together.
              </TitleSerif>

              <p>
                Alhamdulillah, throughout my journey so far, I’ve met some
                pretty awesome individuals and organisations.
              </p>

              <CTAA
                href="https://learnlovelive.co"
                target="_blank"
                rel="noreferrer noopener"
                css={{
                  background: '#9A1E1F',
                  ':hover': { background: '#000' },
                }}
              >
                Visit LearnLoveLive.co
              </CTAA>
            </div>

            <div css={tw`w-full md:w-1/2 px-12`}>
              <Img fluid={data.lll.childImageSharp.fluid} />
            </div>
          </div>
        </Container>
      </Section>

      {/* <Section css={tw`text-sm pt-16 pb-8 bg-blue text-white`}>
        <Blob3
          css={{
            position: 'absolute',
            width: 700,
            zIndex: -2,
            left: -100,
            top: -200,
            opacity: 0.1
          }}
        />

        <Container>
          <div css={[tw`flex flex-wrap`, { margin: '0 -3rem' }]}>
            <div css={tw`w-full md:w-1/2 px-12`}>
              <TitleSans css={tw`mb-12 md:text-4xl`}>
                <span>Love Qur&rsquo;an</span>
                Kengkawan Qur&rsquo;an.
              </TitleSans>

              <p>
                I was born <em>Erwan Bin Taib</em>, on the 19th of July 1976. Since I was small, I
                had an inclination towards the arts, especially music. Early in my childhood, my
                parents sent me to piano lessons and I guess that’s where I got the singing and
                song-writing seed.
              </p>
            </div>
            <div css={tw`w-full md:w-1/2 px-12`}>
              <TitleSans css={tw`mb-12 md:text-4xl`}>
                <span>Something something</span>
                alfaqirwalmajnun
              </TitleSans>

              <p>
                I was born <em>Erwan Bin Taib</em>, on the 19th of July 1976. Since I was small, I
                had an inclination towards the arts, especially music. Early in my childhood, my
                parents sent me to piano lessons and I guess that’s where I got the singing and
                song-writing seed.
              </p>
            </div>
          </div>
        </Container>
      </Section> */}

      <Ending css={tw`pb-0`}>
        <Blob2
          css={{
            fill: colors.white,
            position: 'absolute',
            width: 900,
            zIndex: -2,
            right: -100,
            top: -100,
            opacity: 0.1,
          }}
        />

        <Container css={tw`flex flex-wrap`}>
          <div css={tw`w-full md:w-2/5`} />
          <div css={tw`w-full md:w-3/5`}>
            <div css={tw`max-w-sm pl-0 md:pl-0`}>
              <TitleSerif css={[tw`mb-12 text-yellow-darker`]}>
                <span>Thank you for</span>
                Stopping by.
              </TitleSerif>

              <p style={tw`mb-0`}>
                Find me on social media and let’s stay in touch.
              </p>
              <div css={tw`mb-4`}>
                <a
                  href="https://m.facebook.com/erwanmuhibbaindotco/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
                <a
                  href="https://www.instagram.com/erwanmuhibbain/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
                <a
                  href="https://www.youtube.com/c/ErwanMuhibbain"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Youtube
                </a>
              </div>

              <p>Allah bless.</p>

              <p css={{ marginTop: -20 }}>
                <Sig css={{ width: 250 }} />
              </p>
            </div>
          </div>
        </Container>

        <Footer />
      </Ending>

      <ModalVideo
        channel="youtube"
        isOpen={videoOpen}
        videoId={videoId}
        onClose={() => {
          setVideoOpen(false);
        }}
      />
    </PageTransition>
  );
};

export default IndexPage;

export const query = graphql`
  query {
    erwan: file(relativePath: { eq: "logo.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    hero: file(relativePath: { eq: "bgs/hero.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    hero2: file(relativePath: { eq: "bgs/hero2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    mengenalcinta: file(relativePath: { eq: "albums/mengenalcinta-o.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    floh: file(relativePath: { eq: "albums/floh-o.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    akuhambamu: file(relativePath: { eq: "albums/akuhambamu-o.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    tv: file(relativePath: { eq: "bgs/camera2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    book: file(relativePath: { eq: "book-mockup.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    lll: file(relativePath: { eq: "LLL.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    ending: file(relativePath: { eq: "bgs/ending.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
